import React, { ChangeEventHandler, ReactNode } from "react";

type InputProps = {
  id?: string;
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: ChangeEventHandler;
  min?: number;
  max?: number;
  type?: string;
  suffix?: string | ReactNode;
  disabled?: boolean;
};

export default function InputField({
  id,
  placeholder,
  value,
  onChange,
  min,
  max,
  type,
  suffix,
  disabled = false,
  label,
}: InputProps) {
  return (
    <div className="form-group">
      {label && (
        <label htmlFor={id} className="fs-h4">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={id}
          placeholder={placeholder}
          value={value}
          min={min}
          max={max}
          onChange={onChange}
          type={type}
          className={suffix ? "w-full" : ""}
          size={0}
          disabled={disabled}
        />
        {suffix && (
          <div className="absolute px-4 py-4 top-0 right-0 whitespace-nowrap">
            {suffix}
          </div>
        )}
      </div>
    </div>
  );
}
